
export class CloudFunctionsException extends Error {
  constructor(
    public readonly message: string,

    // The optional code to accommodate the message.
    // Allows users to identify the exception from a short code-name.
    public readonly code: string = 'unknown',
    public readonly internalError: unknown | null = null,
  ) {
    super(message);
  }

  toString(): string {
    return `[${this.code}] ${this.message}`;
  }
}
